import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismMetricBlock } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import hasFeature from 'lumen/helpers/has-feature';

interface HotelPricingAssistantSelfServiceUpsellMetricBlocksOtbSignature {
  Args: {
    isUpsell: boolean;
    showTooltips: boolean;
  };
}

export default class HotelPricingAssistantSelfServiceUpsellMetricBlocksOtb extends Component<HotelPricingAssistantSelfServiceUpsellMetricBlocksOtbSignature> {
  @service declare access: Services['access'];

  <template>
    {{! @glint-nocheck: not typesafe yet }}
    <div class="metric-blocks-container flex flex-row">
      <PrismMetricBlock class="w-1/2">
        <:value>
          <span class={{if @isUpsell "text-brand font-bold"}}>
            {{t "general.missing"}}
          </span>
        </:value>
        <:label>
          <div class="flex items-center justify-center gap-100">
            <span
              class="text-200--regular {{if @isUpsell 'text-brand font-bold'}}"
            >{{t "pricing_assistant.my_OTB"}}</span>
            {{! This component is used in the Pricing Assistant calendar tooltips as well. In that case these aren't very useful }}
            {{#if (and (not @isUpsell) @showTooltips)}}
              <GeneralIconWithTooltip
                @side="top"
                @tooltipContent={{t
                  "pricing_assistant.self_service.data_validation.content"
                }}
                @tooltipTitle={{t
                  "pricing_assistant.self_service.data_validation.title"
                }}
              />
            {{/if}}
          </div>
        </:label>
      </PrismMetricBlock>
      {{#if this.access.hasOTBForecastView}}
        <PrismMetricBlock class="w-1/2">
          <:value>
            <span class={{if @isUpsell "text-brand font-bold"}}>
              {{t "general.missing"}}
            </span>
          </:value>
          <:label>
            <div class="flex items-center justify-center gap-100">
              <span
                class="text-200--regular
                  {{if @isUpsell 'text-brand font-bold'}}"
              >{{t "pricing_assistant.my_forecast"}}</span>
              {{#if (and (not @isUpsell) @showTooltips)}}
                <GeneralIconWithTooltip
                  @side="top"
                  @tooltipContent={{t
                    "pricing_assistant.self_service.data_validation.content"
                  }}
                  @tooltipTitle={{t
                    "pricing_assistant.self_service.data_validation.title"
                  }}
                />
              {{/if}}
            </div>
          </:label>
        </PrismMetricBlock>
      {{/if}}
      {{#if (hasFeature "otb.market_benchmark_eligible")}}
        <PrismMetricBlock class="w-1/2">
          <:value>
            <span class={{if @isUpsell "text-brand font-bold"}}>
              {{t "general.missing"}}
            </span>
          </:value>
          <:label>
            <div class="flex items-center justify-center gap-100">
              <span
                class="text-200--regular
                  {{if @isUpsell 'text-brand font-bold'}}"
              >{{t "rates.tooltip.market_otb"}}</span>
              {{#if (and (not @isUpsell) @showTooltips)}}
                <GeneralIconWithTooltip
                  @side="top"
                  @tooltipContent={{t
                    "pricing_assistant.self_service.data_validation.content"
                  }}
                  @tooltipTitle={{t
                    "pricing_assistant.self_service.data_validation.title"
                  }}
                />
              {{/if}}
            </div>
          </:label>
        </PrismMetricBlock>
      {{/if}}
    </div>
  </template>
}
